import { recentThreadLink } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/recentThreadLink.js';
import { DATABASE_MODE_TYPE_ASI } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/sidebar-recent-items-state/recentItemsTypes.js';
import { isComputerTaskThreadRoute } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/constants.js';
import { isUuid, maybeSlugToUuid } from '#pplx/frontend/apps/ask/permalink-slug/permalinkSlug.js';
const LOCAL_TASK_PREFIX = '/computer/tasks/local-';
export function getSidebarThreadIdentity(item) {
    const isThread = item.variant === 'thread';
    const isComputer = isComputerTaskThreadRoute(item.link) || (isThread && item.mode_type === DATABASE_MODE_TYPE_ASI);
    const localThreadId = isThread &&
        item.link.startsWith(LOCAL_TASK_PREFIX) &&
        isUuid(item.link.slice(LOCAL_TASK_PREFIX.length))
        ? item.link.slice('/computer/tasks/'.length)
        : undefined;
    const entryUUID = localThreadId ??
        maybeSlugToUuid(item.link.split('/').pop() ?? '') ??
        (!item.isStreaming ? item.uuid || undefined : undefined);
    return {
        isThread,
        isComputer,
        entryUUID,
        contextUUID: item.context_uuid ?? undefined,
        collectionUUID: item.collection_uuid ?? undefined,
        href: entryUUID
            ? recentThreadLink({
                entryUuid: entryUUID,
                mode: isComputer ? 'COMPUTER' : undefined,
                variant: isThread ? undefined : 'ARTICLE',
            })
            : undefined,
    };
}
export function getRecentThreadInteractionTarget(item, entryUUID) {
    const contextUUID = item.context_uuid;
    if (!contextUUID)
        return { kind: 'no-context' };
    const collectionUUID = item.collection_uuid;
    return {
        kind: 'thread',
        contextUUID,
        entryUUID,
        unread: item.unread === true,
        // Recents carry the project UUID but not its slug.
        project: collectionUUID
            ? { kind: 'in-project', collectionUUID, collectionSlug: undefined }
            : { kind: 'none' },
    };
}
//# sourceMappingURL=sidebarThreadIdentity.js.map